import { useInView } from '../../hooks/useInView';
import ToolIcon from './ToolIcon';

export default function ToolBenefits({ benefits }) {
  const [ref, inView] = useInView(0.1);

  return (
    <section className="py-20 sm:py-28 bg-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
            Why Use FileMingle?
          </h2>
          <p className="text-slate-500 max-w-xl mx-auto leading-relaxed">
            Everything you need, nothing you don't — fast, private, and free.
          </p>
        </div>

        <div
          ref={ref}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {benefits.map((benefit, i) => (
            <div
              key={benefit.title}
              className="group rounded-2xl border border-slate-100 bg-white p-6 shadow-sm card-hover"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(24px)',
                transition: `opacity 0.5s ease ${i * 0.07}s, transform 0.5s ease ${i * 0.07}s`,
              }}
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-brand-blue/10 to-brand-indigo/10 flex items-center justify-center mb-4 group-hover:from-brand-blue/20 group-hover:to-brand-indigo/20 transition-colors duration-300">
                <ToolIcon name={benefit.icon} size={20} className="text-brand-blue" />
              </div>
              <h3 className="font-bold text-slate-900 mb-2">{benefit.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
